import React from 'react';
import styled, { css } from 'styled-components';

interface TriangleProps {
  color?: string;
  position?: 'left' | 'right';
  orientation?: 'top' | 'bottom';
}

const TriangleStyled = styled.div<TriangleProps>`
  width: 100%;
  height: 180px;
  background-color: ${({ color }) => color || '#242c7c'};
  position: absolute;
  left: 0;
  top: ${({ orientation }) => (orientation === 'top' ? '-178px' : 'auto')};
  bottom: ${({ orientation }) => (orientation === 'bottom' ? '-178px' : 'auto')};

  ${({ position, orientation }) =>
    orientation === 'top'
      ? position === 'right'
        ? css`
            clip-path: polygon(0 100%, 105% 100%, 100% 50%);
            @media (min-width: 768px) {
              clip-path: polygon(0 100%, 105% 100%, 100% 25%);
            }
            @media (min-width: 1024px) {
              clip-path: polygon(0 100%, 105% 100%, 100% 0);
            }
          `
        : css`
            clip-path: polygon(0 100%, 105% 100%, 0 50%);
            @media (min-width: 768px) {
              clip-path: polygon(0 100%, 105% 100%, 0 25%);
            }
            @media (min-width: 1024px) {
              clip-path: polygon(0 100%, 105% 100%, 0 0);
            }
          `
      : position === 'right'
      ? css`
          clip-path: polygon(0 0, 105% 0, 100% 50%);
          @media (min-width: 768px) {
            clip-path: polygon(0 0, 105% 0, 100% 75%);
          }
          @media (min-width: 1024px) {
            clip-path: polygon(0 0, 105% 0, 100% 100%);
          }
        `
      : css`
          clip-path: polygon(0 0, 105% 0, 0 50%);
          @media (min-width: 768px) {
            clip-path: polygon(0 0, 105% 0, 0 75%);
          }
          @media (min-width: 1024px) {
            clip-path: polygon(0 0, 105% 0, 0 100%);
          }
        `}
`;

const Triangle: React.FC<TriangleProps> = ({ color, position = 'left', orientation = 'top' }) => {
  return <TriangleStyled color={color} position={position} orientation={orientation} />;
};

export default Triangle;
